import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
import { Row, Skeleton } from 'antd'
import Avatar from 'antd/lib/avatar/avatar'
import _ from 'lodash'
import serviceInterface from '../../services/service.interface'

const MessageSurgeon = (props) => {
  const [loading, setLoading] = useState(true)
  const [image, setImage] = useState('')

  useEffect(() => loadImage(props.surgeon?._id), [props.surgeon?._id])

  const loadImage = (id) => {
    setLoading(true)
    serviceInterface
      .SurgeonService()
      .getSurgeonImage(id)
      .then((data) => {
        setLoading(false)
        setImage(data.image)
      })
  }

  var className =
    props.surgeon._id == props.filters.surgeonId
      ? 'ms-list-item ms-list-item-selected'
      : 'ms-list-item'
  //hidden={!props.surgeon.showinlist}
  return (
    <Row
      className={className}
      align='middle'
      onClick={() => props.handleClick(props.surgeon)}
    >
      {loading ? (
        <Skeleton.Avatar active={loading} />
      ) : (
        <Avatar src={image}>{props.surgeon?.name[0]?.toUpperCase()}</Avatar>
      )}
      &nbsp;
      <span>{_.upperFirst(props.surgeon.name)}</span>&nbsp;
      <span hidden={props.surgeon.unreadcount === 0}>
        ({props.surgeon.unreadcount})
      </span>
    </Row>
  )
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    user: state.profile.user,
    filters: state.actioncase.filters,
    selectedRequests: state.message.selectedRequests,
    surgeons: state.surgeon.surgeons,
    sort: state.message.sort,
  }
}

export default connect(mapStateToProps, null)(MessageSurgeon)
